import { createContext } from 'react';

const cuentaContext = createContext();

export default cuentaContext;